export const getCursor = (
	currentpageNumber: number,
	newPageNumber: number,
	prevCursor: string,
	nextCursor: string,
) => {
	let cursor;
	if (newPageNumber === currentpageNumber + 1 && nextCursor) {
		cursor = nextCursor;
	} else if (newPageNumber === currentpageNumber - 1 && prevCursor) {
		cursor = prevCursor;
	} else {
		cursor = '';
	}
	return cursor;
};

export const getPageSelectedIndex = (nextCursor: string | null, prevCursor: string | null) =>
	nextCursor && !prevCursor ? 0 : 1;

export const getPagesArray = (
	pageNumber: number,
	maxPages: number,
	prevCursor: string | null,
	nextCursor: string | null,
) => {
	let pagesArray = [pageNumber];
	if (prevCursor && pageNumber !== 1) {
		pagesArray = [pageNumber - 1, ...pagesArray];
	}
	if (nextCursor && pageNumber < maxPages) {
		pagesArray = [...pagesArray, pageNumber + 1];
	}
	return pagesArray;
};
